var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "110px",
    height: "30px",
    viewBox: "0 0 110 30",
    style: {
      enableBackground: "new 0 0 110 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#00002A;}\r\n\t.st2{fill:#0070C3;}\r\n\t.st3{fill:#FFAF00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login-logo",
    transform: "translate(-16 -88)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    x: 16,
    y: 88,
    className: "st0",
    width: 110,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_29",
    transform: "translate(16 88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_25",
    className: "st1",
    d: "M8.4,19.3v4.5H0v5.2h22.1v-5.2h-8.4v-4.5L8.4,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_26",
    className: "st2",
    d: "M11.1,0L11.1,0L0,7.7l0,0v11.6h5.2v-8.9l5.8-4.1l5.8,4.1v8.9h5.2V7.7l0,0L11.1,0L11.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27",
    className: "st1",
    d: "M35.1,19.3v4.5h-8.4v5.2h22.1v-5.2h-8.4v-4.5L35.1,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_28",
    className: "st3",
    d: "M37.8,0L37.8,0L26.7,7.7v11.6h5.2v-8.9l5.8-4.1l5.8,4.1v8.9h5.2V7.7l0,0L37.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_29",
    className: "st1",
    d: "M68.6,4.6h-5V2.1h-5.2v2.5h-5v5.2h1.8c-1.2,1.4-1.8,3.1-1.8,4.8v7c0,4.1,3.3,7.5,7.5,7.5l0,0 h0.3c4.1,0,7.5-3.3,7.5-7.5v-7c0-1.8-0.6-3.5-1.8-4.8h1.8L68.6,4.6z M63.4,21.6c0,1.3-1,2.3-2.3,2.3h-0.3c-1.3,0-2.3-1-2.3-2.3v-7 c0-1.3,1-2.3,2.3-2.3h0.3c1.3,0,2.3,1,2.3,2.3V21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_30",
    className: "st1",
    d: "M77.1,14.2V4.6h-5.2v24.5h5.2v-9.7h4.6v-5.2H77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_31",
    className: "st1",
    d: "M105.3,14.2V4.6h-5.2v24.5h5.2v-9.7h4.6v-5.2H105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_32",
    className: "st1",
    d: "M96.9,9.8V4.6H81.6v5.2h5v4.4l0,0l-5,14.9h5.5l2.1-6.2l2.1,6.2h5.5l-5-14.9V9.8H96.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo_login.0b3ce670253b6843a056e63234d8f97d.svg";
export { ForwardRef as ReactComponent };